import React from "react";
import _ from "lodash";
import { useData } from "../hooks/useContext";
import { IUseData } from "../interfaces";
import { slicer } from "../utils/paginate";

interface IPagination {
  productCount: number;
  pageSize: number;
  currentPage: number;
  onPageChange(page: number): any;
}

const Pagination = ({ productCount, pageSize, currentPage, onPageChange }: IPagination) => {
  const { theme } = useData() as IUseData;
  const pagesCount: number = Math.ceil(productCount / pageSize);

  if (pagesCount <= 1) {
    return null;
  }

  const pagesList: number[] = _.range(1, pagesCount + 1);

  return (
    <div className="flex flex-row justify-center mt-3">
      <nav className="flex flex-row text-[#141B34]">
        <button
          className={
            currentPage === 1
              ? "text-xl h-8 w-8 me-1 border-2 border-[#141B34] rounded bg-white self-center cursor-not-allowed"
              : "text-xl h-8 w-8 me-1 border-2 border-[#141B34] rounded bg-white self-center" + theme.hover
          }
          onClick={() => (currentPage !== 1 ? onPageChange(currentPage - 1) : undefined)}
          title="Предыдущая страница"
        >
          {"<"}
        </button>
        {slicer(pagesList, currentPage).map((item: number) => (
          <button
            key={item}
            className={
              currentPage === item
                ? "text-xl h-8 w-8 me-1 border-2 border-[#141B34] rounded self-center" + theme.secondary
                : "text-xl h-8 w-8 me-1 border-2 border-[#141B34] rounded bg-white self-center" + theme.hover
            }
            onClick={() => onPageChange(item)}
            title={currentPage === item ? "Текущая страница" : "Страница " + item}
          >
            {item}
          </button>
        ))}
        <button
          className={
            currentPage === pagesList[pagesList.length - 1]
              ? "text-xl h-8 w-8 border-2 border-[#141B34] rounded bg-white self-center cursor-not-allowed"
              : "text-xl h-8 w-8 border-2 border-[#141B34] rounded bg-white self-center" + theme.hover
          }
          onClick={() => (currentPage !== pagesList[pagesList.length - 1] ? onPageChange(currentPage + 1) : undefined)}
          title="Следующая страница"
        >
          {">"}
        </button>
      </nav>
    </div>
  );
};

export default Pagination;
